<script>
  import ImpactInvestment from "./Icons/ImpactInvestment.svelte";
  import MissionDriven from "./Icons/MissionDriven.svelte";
  import Nonprofits from "./Icons/Nonprofits.svelte";
  import PolicyGovernment from "./Icons/PolicyGovernment.svelte";

  export let data;
  export let iconHeight;

  import { iconSizeLookup } from "../stores/global.js";

  const componentLookup = {
    "Nonprofits & institutions": Nonprofits,
    "Impact investment": ImpactInvestment,
    "Mission-driven company": MissionDriven,
    "Policy & government": PolicyGovernment,
  };

  $: iconHeight = $iconSizeLookup[data.size];
</script>

<div class="icon-container">
  <svelte:component
    this={componentLookup[data.type]}
    size={$iconSizeLookup[data.size]}
  />
  <slot />
</div>

<style>
  .icon-container {
    text-align: center;
    flex-shrink: 0;
    height: 100%;
    z-index: 2;
    position: relative;
    display: flex;
    place-items: center;
  }

  :global(.icon) {
    margin: 0 auto;
    height: 100%;
    z-index: 5;
    position: relative;
    pointer-events: none;
    transition: opacity 300ms linear;
  }

  :global(.active .icon) {
    animation: rotate 500ms ease;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
